import { render, staticRenderFns } from "./deliveryCharges.vue?vue&type=template&id=231f470f&scoped=true&"
import script from "./deliveryCharges.vue?vue&type=script&lang=js&"
export * from "./deliveryCharges.vue?vue&type=script&lang=js&"
import style0 from "./deliveryCharges.vue?vue&type=style&index=0&id=231f470f&lang=scss&scoped=true&"
import style1 from "./deliveryCharges.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./deliveryCharges.vue?vue&type=style&index=2&id=231f470f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f470f",
  null
  
)

export default component.exports